import type { GeneratedQuery } from "@/features/chat/model/chatTypes";

export function getPrimarySqlFromQueries(
  generatedQueries: GeneratedQuery[] | null | undefined,
): string | null {
  if (!generatedQueries?.length) {
    return null;
  }
  const succeeded = generatedQueries.find(
    (query) => typeof query.sql === "string" && query.sql.trim() && query.status !== "failed",
  );
  if (succeeded?.sql?.trim()) {
    return succeeded.sql.trim();
  }
  const fallback = generatedQueries.find((query) => typeof query.sql === "string" && query.sql.trim());
  return fallback?.sql?.trim() ?? null;
}
